import type Fuse from "fuse.js";
import { type ReactNode } from "react";

export const markHighlights = (text: unknown, indices?: Fuse.FuseResultMatch["indices"]) => {
	if (text === undefined) {
		return undefined;
	}

	if (indices === undefined) {
		return String(text);
	}

	if (typeof text !== "string") {
		return String(text);
	}

	const markedText: ReactNode[] = [];
	let lastEnd = 0;
	indices?.forEach(([start, end]) => {
		markedText.push(text.slice(lastEnd, start));
		markedText.push(
			<span
				className="text-primary"
				style={{ background: "rgba(254, 249, 100, 0.8)" }}
				key={start}
			>
				{text.slice(start, end + 1)}
			</span>
		);
		lastEnd = end + 1;
	});
	markedText.push(text.slice(lastEnd));
	return markedText;
};
